import { useTranslation } from "@vixi/localization";
import { ComponentProps, forwardRef } from "react";
import { cn } from "@/lib";

const EmptyAvatarGridItemRoot = ({ className, ...props }: ComponentProps<"div">) => {
  return (
    <div
      className={cn(
        "bg-paper border-primary-light aspect-229.35/378.03 relative flex w-full flex-col overflow-hidden rounded-md border-3 border-dashed",
        className,
      )}
      {...props}
    />
  );
};

export const EmptyAvatarGridItem = forwardRef<HTMLDivElement, ComponentProps<"div">>(
  (props, ref) => {
    const { t } = useTranslation();

    return (
      <EmptyAvatarGridItemRoot ref={ref} {...props}>
        <p className="text-text-secondary m-auto text-center select-none">
          {t("Courses.SelectAnAvatar")}
          <br />
          {t("Common.FromBelow")}
        </p>

        <div>{props.children}</div>
      </EmptyAvatarGridItemRoot>
    );
  },
);
